define((require) => {
    "use strict";

    const ImprovedModel = require("shared/zbone/ImprovedModel");

    /**
     * Describes a layout breakpoint - holding the amount of space needed to cover a specific range of viewport sizes.
     *
     * @class Breakpoint
     */
    const Breakpoint = ImprovedModel.extend("Breakpoint", {

        defaults: {
            /**
             * The space covered by *this* breakpoint in pixels - or an object containing a <tt>threshold</tt> property.
             *
             * @type {Number}
             */
            threshold: NaN
        },

        getIdentifier() {
            return this.get("threshold");
        }
    });

    /**
     * Constant value representing a "starting" breakpoint.
     *
     * @type {Breakpoint}
     */
    Breakpoint.BEGIN = new Breakpoint({threshold: 0});

    /**
     * Constant value representing an "infinity" breakpoint.
     *
     * @type {Breakpoint}
     */
    Breakpoint.INFINITY = new Breakpoint({threshold: Number.POSITIVE_INFINITY});

    return Breakpoint;
});



// WEBPACK FOOTER //
// ./src/shared/ui/breakpoint/Breakpoint.js